import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Brightness4 from '@material-ui/icons/Brightness4'
import { useColorMode } from './ThemeProvider'

export default function ThemeToggle() {
  const { mode, toggleMode } = useColorMode()
  const label = `Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`

  return (
    <Tooltip title={label}>
      <IconButton color="inherit" aria-label={label} onClick={toggleMode}>
        <Brightness4 />
      </IconButton>
    </Tooltip>
  )
}
